import { CostCentreService } from './cost-centre.service';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { COST_CENTRE_TYPE, CostCentre } from 'assets-model';
import { Observable } from 'rxjs';



@Injectable({ providedIn: 'root' })
export abstract class CostCentreResolverBase implements Resolve<CostCentre> {

  constructor(protected service: CostCentreService) {
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<CostCentre> {
    const key: string = COST_CENTRE_TYPE.entityDecorator.toKeyObjectFromRouteParams(route.params);
    return this.service.get(key);
  }
}



